import React from 'react';
import Materia from './materia';
import Semestre from './semestre';

function Anio({anio, semestre2, semestre1, todo}) {
    
    if(todo){
        return (
            <ul className="anios">
                <li className="desplegado">
                    <div className="li">
                        <div className="linea_an"></div>
                        <div className="bola_an"></div>
                        <span className="num_an">{anio}</span> <span className="txt_an">Año</span>
                    </div>

                    <ul className="materia">
                        { todo.map( materia => {           
                                return (
                                    <Materia key={materia.id} data={materia} />
                                );
                            })
                        }            
                    </ul>

                </li>
            </ul>
        );
    }else if(semestre2.length< 1 && semestre1.length< 1) {
        return null;
    }else{

        return (
            <ul className="anios">
                <li className="desplegado">
                    <div className="li">
                        <div className="linea_an"></div>
                        <div className="bola_an"></div>
                        <span className="num_an">{anio}</span> <span className="txt_an">Año</span>
                    </div>

                    <Semestre titulo='Segundo semestre' semestre={semestre2} />

                    <Semestre titulo='Primer semestre' semestre={semestre1} />

                </li>
            </ul>
        );
    }
}

export default React.memo(Anio);